import api from "@helpers/api";

import { URLS } from "@constants/urls";

import {
  ChildType,
  FamilyType,
  ParentType,
  SpouseType,
  EmergencyContactType,
  PermanentAddressType,
  PresentAddressType,
  RationType,
} from "@type/HRM/family";
import { STATUS } from "@constants/status.hrm";

const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const getFamily = (() => {
  return async (data: { data: string }): Promise<{ data: FamilyType }> => {
    const id = data.data;
    return api
      .get(`${apiEndPoint}/${id}/family-info`)
      .then((response) => ({ data: response.data }));
  };
})();

export const updateParentInfo = (() => {
  return async (data: { data: ParentType }): Promise<{ data: ParentType }> => {
    const { employeeID, ...rest } = data.data;
    const { fathersId, mothersId } = rest;

    const url = `${apiEndPoint}/${employeeID}/family-info/parents`;
    const action = fathersId && mothersId ? "put" : "post";

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const updateSpouseInfo = (() => {
  return async (data: { data: SpouseType }): Promise<{ data: SpouseType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const postUrl = `${apiEndPoint}/${employeeID}/family-info/members`;
    const putUrl = `${apiEndPoint}/${employeeID}/family-info/members/${id}`;

    const url = id ? putUrl : postUrl;

    return api[action](url, {
      ...rest,
      relationshipId: 57,
    }).then((response) => ({ data: response.data }));
  };
})();

export const deleteSpouseInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; spouseID: number };
  }): Promise<{ data: { id: number } }> => {
    const { employeeID, spouseID } = data.data;

    return api
      .delete(`${apiEndPoint}/${employeeID}/family-info/members/${spouseID}`)
      .then(() => ({ data: { id: spouseID } }));
  };
})();

export const updateChildInfo = (() => {
  return async (data: { data: ChildType }): Promise<{ data: ChildType }> => {
    const { id, ...rest } = data.data;

    const postUrl = `${apiEndPoint}/${rest.employeeID}/family-info/members`;
    const putUrl = `${apiEndPoint}/${rest.employeeID}/family-info/members/${id}`;

    const url = id ? putUrl : postUrl;

    const action = id ? "put" : "post";

    return api[action](url, {
      ...rest,
      relationshipId: 58,
    }).then((response) => ({ data: response.data }));
  };
})();

export const deleteChildInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; childID: number };
  }): Promise<{ data: { id: number } }> => {
    const { employeeID, childID } = data.data;

    return api
      .delete(`${apiEndPoint}/${employeeID}/family-info/members/${childID}`)
      .then(() => ({ data: { id: childID } }));
  };
})();

export const updateEmergencyContactInfo = (() => {
  return async (data: {
    data: EmergencyContactType;
  }): Promise<{ data: EmergencyContactType }> => {
    const { id, ...rest } = data.data;

    const postUrl = `${apiEndPoint}/${rest.employeeID}/family-info/members`;
    const putUrl = `${apiEndPoint}/${rest.employeeID}/family-info/members/${id}`;

    const url = id ? putUrl : postUrl;

    const action = id ? "put" : "post";

    return api[action](url, {
      ...rest,
      relationshipId: 58,
    }).then((response) => ({ data: response.data }));
  };
})();

export const updatePermanentAddressInfo = (() => {
  return async (data: {
    data: PermanentAddressType;
  }): Promise<{ data: PermanentAddressType }> => {
    const { id, employeeID, ...rest } = data.data;

    const postUrl = `${apiEndPoint}/${employeeID}/family-info/employee-addresses`;
    const putUrl = `${apiEndPoint}/${employeeID}/family-info/employee-addresses/${id}`;

    const url = id ? putUrl : postUrl;
    const action = id ? "put" : "post";

    return api[action](url, {
      ...rest,
      addressTypeId: 60,
    }).then((response) => ({ data: response.data }));
  };
})();

export const updatePresentAddressInfo = (() => {
  return async (data: {
    data: PresentAddressType;
  }): Promise<{ data: PresentAddressType }> => {
    const { id, employeeID, ...rest } = data.data;

    const postUrl = `${apiEndPoint}/${employeeID}/family-info/employee-addresses`;
    const putUrl = `${apiEndPoint}/${employeeID}/family-info/employee-addresses/${id}`;

    const url = id ? putUrl : postUrl;
    const action = id ? "put" : "post";
    return api[action](url, {
      ...rest,
      addressTypeId: 59,
    }).then((response) => ({ data: response.data }));
  };
})();

export const getRation = (() => {
  return async (employeeID: string | number | null) => {
    return api
      .get(`${apiEndPoint}/${employeeID}/ration-info`)
      .then((response) => {
        return {
          data: response,
        };
      });
  };
})();
export const updateRationInfo = (() => {
  return async (
    employeeID: string | number | null,
    data: RationType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(`${apiEndPoint}/${employeeID}/ration-info`, {
        ...data,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });
        return {
          data: response,
        };
      });
  };
})();
